import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SetLandingPageDomain as SetLandingPageDomainMutation,
    SetLandingPageDomainVariables as SetLandingPageDomainVariables,
    LandingPageDomainSetInput,
} from 'nutshell-graphql-types';

import SET_LANDING_PAGE_DOMAIN from '../mutations/set-landing-page-domain.graphql';

export const useSetLandingPageDomain = (): {
    setLandingPageDomain: (arg1: LandingPageDomainSetInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [setLandingPageDomain, {loading, error}] = useMutation<
        SetLandingPageDomainMutation,
        SetLandingPageDomainVariables
    >(SET_LANDING_PAGE_DOMAIN);

    return {
        setLandingPageDomain: (input: LandingPageDomainSetInput) =>
            setLandingPageDomain({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
